import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, getReportsToken, setReportsToken } from "@/lib/api";
import { LogOut } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import ReportsPanel from "@/components/admin/ReportsPanel";

export default function ReportsView() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = getReportsToken();
    if (!token) {
      navigate("/reports", { replace: true });
      return;
    }
    // Ensure the axios Bearer header carries the reports token for this session.
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setReady(true);
  }, [navigate]);

  const logout = () => {
    setReportsToken(null);
    navigate("/reports", { replace: true });
  };

  if (!ready) return null;

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <header className="border-b-4 border-black px-6 py-4 flex items-center justify-between sticky top-0 bg-[#FDFBF7] z-10">
        <BrandLogo size="md" title="Reports Portal" subtitle="Daily player reports · downloadable images" />
        <button data-testid="reports-logout-btn" onClick={logout} className="brutal-btn-secondary text-sm flex items-center gap-2">
          <LogOut size={16} /> Log Out
        </button>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8" data-testid="reports-portal">
        <ReportsPanel />
      </main>
    </div>
  );
}
